/** Rakamlar (yalnizca 0-9). */
export function extractPhoneDigits(value: string): string {
  return value.replace(/\D/g, "");
}

/** Turk cep: 10 hane (5...) veya 11 hane (05...). Bos = gecerli. */
export function validateTurkishPhone(digits: string): string | null {
  if (!digits) return null;
  if (digits.length === 11) {
    if (!digits.startsWith("0")) {
      return "11 haneli numara sifirin (0) ile baslamalidir.";
    }
    if (!digits.startsWith("05")) {
      return "Gecerli bir cep telefonu numarasi girin (05 ile baslamali).";
    }
    return null;
  }
  if (digits.length === 10) {
    if (!digits.startsWith("5")) {
      return "10 haneli numara 5 ile baslamalidir.";
    }
    return null;
  }
  return `Telefon numarasi ${digits.length} hane; 10 veya 11 hane olmalidir (ornek: 0555 685 75 80).`;
}

function formatLeadingZeroDigits(digits: string): string {
  const d = digits.slice(0, 11);
  const parts = [d.slice(0, 4), d.slice(4, 7), d.slice(7, 9), d.slice(9, 11)].filter((p) => p.length > 0);
  return parts.join(" ");
}

function formatTenDigitMobile(digits: string): string {
  const d = digits.slice(0, 10);
  const parts = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter((p) => p.length > 0);
  return parts.join(" ");
}

/** Görünümleme / kayit: tam veya kismi numarayi bosluklu formata cevirir (11 hane, 0 ile). */
export function formatPhoneDisplay(value: string | null | undefined): string {
  const digits = extractPhoneDigits(value ?? "");
  if (!digits) return "";
  const canonical =
    digits.length === 10 && digits.startsWith("5") ? `0${digits}` : digits;
  if (canonical.startsWith("0")) {
    return formatLeadingZeroDigits(canonical);
  }
  return formatTenDigitMobile(canonical);
}

/** Yazarken input degerini formatlar (en fazla 11 rakam). */
export function formatPhoneInput(raw: string): string {
  let digits = extractPhoneDigits(raw);
  if (digits.length > 11) digits = digits.slice(0, 11);
  if (digits.startsWith("0") || digits === "") {
    return formatLeadingZeroDigits(digits);
  }
  return formatTenDigitMobile(digits.slice(0, 10));
}

/** API'ye gonderilecek normalize edilmis gorunum (11 hane, 0 ile). */
export function normalizePhoneForApi(display: string | null | undefined): string | null {
  const digits = extractPhoneDigits(display ?? "");
  if (!digits) return null;
  const canonical =
    digits.length === 10 && digits.startsWith("5") ? `0${digits}` : digits;
  return formatPhoneDisplay(canonical);
}
